import { render, staticRenderFns } from "./TheConver.vue?vue&type=template&id=05b183ea&scoped=true"
import script from "./TheConver.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheConver.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheConver.vue?vue&type=style&index=0&id=05b183ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b183ea",
  null
  
)

export default component.exports